import { Box, Button, Typography } from '@mui/material'
import { Trans } from '@lingui/macro'
import { FC } from 'react'
import { isNil } from 'lodash'
import CustomButton from '../CustomButton'
import { ContactDialogType } from './useContactDialog'

interface ContactFieldsErrorResultsProps {
  loading: boolean
  searchResult: string
  preview: boolean
  onModifySearch?: () => void
  onCreateNewContact?: () => void
  type?: ContactDialogType
  role?: string
}

export const ContactFieldsErrorResults: FC<ContactFieldsErrorResultsProps> = ({
  loading,
  searchResult,
  preview,
  onModifySearch,
  onCreateNewContact,
  type,
  role
}) => {
  return (
    <>
      <Box
        sx={{
          marginTop: '18px',
          marginBottom: '48px',
          fontWeight: 'bold',
          fontSize: 24,
          lineHeight: '28px',
          color: 'primary.main',
          textAlign: 'center'
        }}
      >
        {type === 'project-affiliations' && !isNil(role)
          ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
              <Trans>PROJECT_AFFILIATIONS_ADD_TITLE</Trans>
              <Box>{role}</Box>
            </Box>)
          : <Trans>ADD_LEGAL_CONTACT_TITLE</Trans>}
      </Box>
      <Typography
        variant='h2'
        sx={{
          fontSize: 20,
          lineHeight: '25px',
          fontWeight: 700,
          paddingBottom: '32px',
          color: 'primary.main'
        }}
      >
        <Trans>SEARCH_RESULTS_TITLE</Trans>
      </Typography>
      <Box
        style={{
          padding: '9px 12px',
          border: 'none',
          outline: '0.25px solid rgba(0, 0, 0, 0.25)',
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: 400,
          color: '#17374F'
        }}
      >
        {searchResult}
      </Box>
      <Box sx={{ display: 'flex', gap: '16px', marginTop: '32px' }}>
        <Button
          disabled={loading || preview}
          variant='contained'
          sx={{ flex: 1 }}
          color='primary'
          onClick={() => {
            if (!isNil(onCreateNewContact)) {
              onCreateNewContact()
            }
          }}
        >
          <Trans>Create new contact</Trans>
        </Button>
        <CustomButton
          variant='outlined'
          sx={{ height: '35px' }}
          onClick={() => {
            if (!isNil(onModifySearch)) {
              onModifySearch()
            }
          }}
        >
          <Trans>MODIFY_SEARCH_BTN</Trans>
        </CustomButton>
      </Box>
    </>
  )
}
